var SPACE_REGEX = /\s+/g;

export default function removeClass(element, className) {
    if (element && element.className) {
        element.className = element.className.replace(className, "").replace(SPACE_REGEX, " ");
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/common/remove-class.js
// module id = 2349
// module chunks = 29